import React, { useState } from "react";
import { auth, db } from "../FirebaseComp/firebase"; // Import auth and db
import { useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; // Import Firestore methods
import './login.css'; // Your custom CSS for login page

function Login() {
    const auth = getAuth(); // Ensure auth is initialized


  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

 const handleLogin = async (e) => {
  e.preventDefault();
  setError(""); // Reset error messages

  if (!email || !password) {
    setError("Please fill in both email and password.");
    return;
  }

  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user; // Get user immediately after login

    console.log("Logged in user:", user);

    if (user) {
      navigate("/body"); // Navigate to the dashboard if login is successful
    } else {
      setError("Failed to retrieve user information.");
    }
  } catch (err) {
    console.error("Login error: ", err);
    setError("Failed to login. Please check your credentials.");
  }
};


  return (
<div className="login-container">
  <div className="logo-container">
    <img src="logo192.png" alt="Hero Cleaning Service Logo" className="logo" />
  </div>
  <h2>Login</h2>
  <p className="login-description">
    Welcome to Retionz Cabs System. Please log in to access your dashboard and manage your services efficiently.
  </p>
  <form onSubmit={handleLogin}>
    <div className="input-group">
      <label>Email</label>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
    </div>
    <div className="input-group">
      <label>Password</label>
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
    </div>
    <button className="button-login" type="submit">Login</button>
  </form>
  {error && <p class="error">{error}</p>}





<div className="powered-by-footer">
  <img 
    src="glaxmore_logo.png" 
    alt="GLAXMORE Logo" 
    className="learnex-logo" 
  />
  <p className="powered-text">Powered by 
  <a 
    className="glaxmore-link" 
    href="https://www.glaxmore.com" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    &ensp; GLAXMORE
  </a>
</p>
</div>




</div>
  );
}

export default Login;